import React from 'react';
import './styles.css';

const MediakitCardShimmer = () =>
{
	return (
		<div className='flexCol'>
			<div className='flexWrap'>
				{[ 1, 2, 3, 4, 5, 6, 7, 8 ].map((e) => (
					<div className='oneFourthWidth pdngXS' key={e}>
						<div className='mediaKitCardShimmer brdrRadiusSM'>
							<div className='mediaKitCardshimmerBG mediaCardHeight'>
								<div className='CheckBoxShimmer checkBocloadingShimmer' />
							</div>
							<div className='p-12 flexRow alignCntr'>
								<div className='pdngRSM'>
									<div className='iconWidth' />
								</div>
								<div className='flexCol'>
									<div className='shimmerBG folderNameHeight endHeight' />
									<div className='shimmerBG folderNameHeight' />
								</div>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default MediakitCardShimmer;
